import React, { useCallback } from 'react'

import { css } from 'design'

import { useNavAndClearSelected } from '../../hooks/app_location/use_nav_and_clear_selected'
import { getRoutes } from '../../reduxes/slices/routes/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { UpgradePromptButton } from './upgrade_prompt_button'

export const TimelinesLimitWarning = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => {
  const routes: any = useSelectorDelegateStore(getRoutes)
  const navAndClearSelected = useNavAndClearSelected()

  const goToPlans = useCallback(() => {
    navAndClearSelected(routes.admin_app_billing.path)
  }, [routes.admin_app_billing.path, navAndClearSelected])

  return (
    <UpgradePromptButton
      className={upgradePromptStyles()}
      onClick={goToPlans}
      {...props}
    >
      <span>
        You have almost reached the 10,000 message history limit. We will start
        archiving older messages once you reach the limit. Not to worry as you
        can gain access to your older messages at any point in time by upgrading
        your plan.
      </span>
      <div>
        View plans&nbsp;
        <i className="fas fa-chevron-right" />
      </div>
    </UpgradePromptButton>
  )
}

const upgradePromptStyles = css({
  margin: '$4',
  padding: '$4',
})
